const reqs_compras = state => state.reqs_compras;
const reqs_compras_cotizar = state => state.reqs_compras;

export default {
  reqs_compras,
  reqs_compras_cotizar,
};